<template>
  <b-container class="p-0">
    <b-alert variant="success" :show="renewal_id !== null">
      There is a renewal for this policy <a :href="`/policy/${renewal_id}`">View Policy</a>
    </b-alert>
    <b-alert variant="danger" :show="expired && renewal_id === null">
      Policy Expiring! This policy is near or has passed it's renewal date. <a :href="`/policy/${policy.id}/renew`"
        class="text-danger">Renew
        Now</a>
    </b-alert>
    <b-row>
      <b-col md="8">
        <b-button :href="`/policy/${policy.id}/edit`" class="float-right">Edit</b-button>
        <h1>
          <b-badge variant="secondary">
            {{ statuses[policy.policy_status_id] }}
          </b-badge>
          {{ policy.policy_type_name }} Policy {{ policy.policy_number }}
        </h1>
        <table class="table table-condensed">
          <tbody>
            <tr>
              <td><strong>Last Updated</strong></td>
              <td>{{ policy.date_updated | fullDate }}</td>
            </tr>
            <tr>
              <td nowrap=""><strong>Line of Coverage</strong></td>
              <td>
                <span
  v-if="lineofcoverage.details !== ''"
  class="btn btn-success float-right"
  style="padding: 0 3px 0 3px"
  @click="showLineMore = !showLineMore"
>
  <i class="glyphicon glyphicon-usd" style="line-height: normal; margin-top: 2px" title="Show Coverage Details"></i>
  Quote Now
</span>
                {{ policy.lineofcoverage_name }}

<br clear="all">
<!-- Line More section -->
<b-card id="linemore" bg-variant="light" v-show="showLineMore">
  <b-card-text v-html="processedLineDetails" class="rich-text-content"></b-card-text>

  </b-card>
    
              </td>
            </tr>
            <tr>
              <td><strong>Risk Type</strong></td>
              <td>{{ policy.policy_type_name }}</td>
            </tr>
            <tr>
              <td><strong>Effective</strong></td>
              <td>
                {{ policy.date_effective | onlyDate }} to
                {{ policy.date_renewal | onlyDate }} (12 Months)
              </td>
            </tr>
            <tr>
              <td nowrap=""><strong>Description of Risk</strong></td>
              <td>{{ policy.description_of_risk }}</td>
            </tr>
<tr v-if="agency">
  <td nowrap><strong>General Agent</strong></td>
  <td>
    <span class="float-right">
      <a
        v-if="agency.attribute7 && agency.attribute7.includes('@')"
        :href="`mailto:${agency.attribute7}?subject=Ref: Policy ${policy.policy_number}`"
        class="btn btn-secondary btn-sm mr-1"
        target="_blank"
        :title="`Email ${agency.name}`"
      >
        <font-awesome-icon icon="envelope" />
      </a>

      <a
        v-if="agency.attribute5 && agency.attribute5.includes('://')"
        :href="agency.attribute5"
        target="_blank"
        class="btn btn-secondary btn-sm"
        title="Visit Website"
      >
        <font-awesome-icon icon="external-link-alt" />
      </a>
    </span>

    <button
      class="btn btn-outline-secondary btn-sm mr-1"
      @click="toggleAgencyMore"
      :title="showAgencyMore ? 'Hide details' : 'Show details'"
    >
      <font-awesome-icon :icon="['fas', showAgencyMore ? 'chevron-up' : 'chevron-down']" />
    </button>

    <a :href="`/aspect/${agency.id}`">
      <font-awesome-icon icon="external-link-alt" class="mr-1" />
      {{ agency.name }}
    </a>

    <div :id="`asb${agency.id}`" v-show="showAgencyMore" style="padding: 7px; padding-left: 25px;">
      <span v-if="!agencyDetail" class="text-muted small">Loading...</span>
      <b-list-group v-else-if="agencyDetail.attributes && agencyDetail.attributes.length > 0">
        <b-list-group-item
          v-for="attr in agencyDetail.attributes"
          :key="attr.label"
          class="py-1 px-2"
        >
          <strong>{{ attr.label }}:</strong> {{ attr.data }}
        </b-list-group-item>
      </b-list-group>
    </div>
  </td>
</tr>


<tr v-if="insurance_co">
  <td nowrap><strong>Insurance Company</strong></td>
  <td>
    <span class="float-right">
      <a
        v-if="insurance_co.attribute7 && insurance_co.attribute7.includes('@')"
        :href="`mailto:${insurance_co.attribute7}?subject=Ref: Policy ${policy.policy_number}`"
        class="btn btn-default btn-sm"
        target="_blank"
        :title="`Email ${insurance_co.name}`"
      >
        <font-awesome-icon icon="envelope" />
      </a>

      <a
        v-if="insurance_co.attribute5 && insurance_co.attribute5.includes('://')"
        :href="insurance_co.attribute5"
        target="_blank"
        class="btn btn-default btn-sm"
        title="Visit Website"
      >
        <font-awesome-icon icon="external-link-alt" />
      </a>
    </span>

    <button
      class="btn btn-outline-secondary btn-sm mr-1"
      @click="toggleInsuranceMore"
      :title="showInsuranceMore ? 'Hide details' : 'Show details'"
    >
      <font-awesome-icon :icon="['fas', showInsuranceMore ? 'chevron-up' : 'chevron-down']" />
    </button>

    <a :href="`/aspect/${insurance_co.id}`">
      <font-awesome-icon icon="external-link-alt" class="mr-1" />
      {{ insurance_co.name }}
    </a>

    <div :id="`asb${insurance_co.id}`" v-show="showInsuranceMore" style="padding: 7px; padding-left: 25px;">
      <span v-if="!insuranceDetail" class="text-muted small">Loading...</span>
      <b-list-group v-else-if="insuranceDetail.attributes && insuranceDetail.attributes.length > 0">
        <b-list-group-item
          v-for="attr in insuranceDetail.attributes"
          :key="attr.label"
          class="py-1 px-2"
        >
          <strong>{{ attr.label }}:</strong> {{ attr.data }}
        </b-list-group-item>
      </b-list-group>
    </div>
  </td>
</tr>

          </tbody>
        </table>
      </b-col>
      <b-col md="4">
        <b-list-group>
          <b-list-group-item show v-if="agent_sales.length > 0"><strong>Sales Agent:</strong>
            <b-link :href="`/user/${agent_sales[0].id}`"><b-icon icon="file-person"></b-icon>
              {{ agent_sales[0].name_display }}</b-link></b-list-group-item>
          <b-list-group-item show v-if="agent_service.length > 0"><strong>Customer Service:</strong>
            <b-link :href="`/user/${agent_service[0].id}`"><b-icon icon="file-person"></b-icon>
              {{ agent_service[0].name_display }}</b-link></b-list-group-item>
          <b-list-group-item show v-if="agent_renewals.length > 0"><strong>Renewal Processor:</strong>
            <b-link :href="`/user/${agent_renewals[0].id}`"><b-icon icon="file-person"></b-icon>
              {{ agent_renewals[0].name_display }}</b-link></b-list-group-item>
        </b-list-group>
        <b-list-group class="mt-2">
          <b-list-group-item class="d-flex justify-content-between align-items-center"><strong>Payments</strong>
            <b-badge variant="light">Due 12/31/1969</b-badge>
          </b-list-group-item>
          <b-list-group-item variant="success" class="d-flex justify-content-between align-items-center">
            Total Premium ({{ payment_summary.premium / 12 | money }}/month)
            <b-badge variant="success">{{ payment_summary.premium | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Deposits
            <b-badge variant="light">{{ payment_summary.deposits | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Rebates
            <b-badge variant="light">{{ payment_summary.rebates | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Other (not applied to balance)
            <b-badge variant="light">{{ payment_summary.other | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item variant="info" class="d-flex justify-content-between align-items-center">
            Outstanding Balance
            <b-badge variant="info">{{ payment_summary.balance | money }}</b-badge>
          </b-list-group-item>
        </b-list-group>
        <b-list-group class="mt-2">
          <b-list-group-item><strong>Commission Summary</strong></b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Total Amount
            <b-badge variant="light">{{ commissions_summary.total_amount | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Amount Received
            <b-badge variant="light">{{ commissions_summary.amount_received | money }}</b-badge>
          </b-list-group-item>
          <b-list-group-item variant="danger" class="d-flex justify-content-between align-items-center">
            Outstanding Commission
            <b-badge variant="danger">{{ commissions_summary.amount_remaining | money }}</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <br clear="all" />

    <b-tabs content-class="mt-3">
      <b-tab title="Aspects">
        <AspectsList :list="aspects" :ref_id="this.$route.params.policy_key" :ref_type="`policy`"
          form_type="881630ac-637c-11e4-a2c8-b47944e6b4d5" @insurance_co="updateInsurance" @agency="updateAgency" />
      </b-tab>
      <b-tab title="Tasks">
        <TasksList :ref_id="this.$route.params.policy_key" parent_type="policy" />
      </b-tab>
      <b-tab title="Notes">
        <NotesList parent_type="policy" :ref_id="this.$route.params.policy_key" />
      </b-tab>

      <b-tab title="Attachments">
        <AttachmentsList :list="attachments" :ref_id="this.$route.params.policy_key" ref_type="policy"
          @update="attached" />
      </b-tab>
      <b-tab title="Payments">
          <PaymentsList ref_type="policy" :ref_id="this.$route.params.policy_key" @paymentchange="loadPaymentSummary" />
        </b-tab> 
      <b-tab title="Docs">
        <DocsList ref_type="policy" :ref_id="this.$route.params.policy_key" />
      </b-tab>       
    </b-tabs>
  </b-container>
</template>
<script>
import PolicyDataService from '@/services/PolicyDataService'
import UserDataService from '@/services/UserDataService'
import AttachmentDataService from "@/services/AttachmentDataService";
import LinesofcoverageDataService from '@/services/LinesofcoverageDataService';
import AspectDataService from '@/services/AspectDataService';

export default {
  props: ['company'],
  components: {
    AspectsList: () => import('../Aspect/AspectsList.vue'),
    NotesList: () => import('../Note/NotesList.vue'),
    AttachmentsList: () => import('../Attachment/AttachmentsList.vue'),
    TasksList: () => import('../Task/TasksList.vue'),
    PaymentsList: () => import('../Payment/PaymentsList.vue'),
    DocsList: () => import('../Doc/DocsList.vue'),
  },
  data() {
    return {
      showLineMore: false,
      policy: [],
      agent_sales: [],
      agent_service: [],
      agent_renewals: [],
      lineofcoverage: [],
      renewal_id: null,
      date_renewal: null,
      date_effective: null,
      expired: null,
      attached_data: false,
      currentYear: new Date().getFullYear(),
      agency: [],
      attachments: [],
      insurance_co: [],
      showInsuranceMore: false,
      showAgencyMore: false,
      insuranceDetail: null,
      agencyDetail: null,
      aspects: [],
      payments: [],
      commissions: [],
      commissions_summary: [],
      sidebarad: false,
      payment_summary: [],
      statuses: [
        'Unknown',
        'New',
        'Pending Underwriting',
        'Approved',
        'Expired',
        'Cancelled',
        'Quoting',
        'Quoted',
        'Unbound Renewal'
      ]
    }
  },
  created() {
    PolicyDataService.getById(this.$route.params.policy_key)
      .then(res => {
        if (res.data === undefined) {
          window.location = '/404'
        }

        this.policy = res.data

        if (res.data.date_renewal.length >= 0) {
          this.renewal_id = res.data.policy_renewal
          this.date_renewal = res.data.date_renewal
        }
        this.date_effective = res.data.date_effective

        let date1 = new Date(this.date_renewal)
        let date2 = new Date()
        if (date1 < date2) {
          this.expired = true
        }

        this.get_user(res.data.user_id, 'agent_sales')

        if (res.data.servicing_user_id !== null) {
          this.get_user(res.data.servicing_user_id, 'agent_service')
        }

        if (res.data.writing_user_id !== null) {
          this.get_user(res.data.writing_user_id, 'agent_renewals')
        }
        this.policy = res.data

        PolicyDataService.getPayments(this.$route.params.policy_key).then(
          res => {
            this.payments = res.data
            this.payment_summary = res.meta
          }
        )

        PolicyDataService.getCommissions(this.$route.params.policy_key).then(
          res => {
            this.commissions = res.data
            this.commissions_summary = res.meta
          }
        )

        AttachmentDataService.getByRef(this.$route.params.policy_key).then((res) => {
          this.attachments = res.data;
        });

        /// http://127.0.0.1:3000/api/linesofcoverage/19

        LinesofcoverageDataService.getById(this.policy.policy_linesofcoverage_id).then((res) => {

          this.lineofcoverage = res.data
          
        })

      })
      .catch(err => {
        // emit vuejs error event
        this.$emit('error', err)
      })
  },
  computed: {
    processedLineDetails() {
      if (!this.lineofcoverage.details) {
        return '';
      }

      // Process the HTML to ensure links work properly
      let html = this.lineofcoverage.details;

      // Create a temporary element to parse HTML
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // Find all links and ensure they have proper attributes
      const links = temp.querySelectorAll('a');
      links.forEach(link => {
        // Ensure links open in new tab if they're external
        if (link.href && !link.href.startsWith(window.location.origin)) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }

        // Ensure links have proper styling class
        if (!link.classList.contains('rich-text-link')) {
          link.classList.add('rich-text-link');
        }

        // Fix any relative URLs
        if (link.href && link.href.startsWith('/')) {
          link.href = window.location.origin + link.href;
        }
      });

      return temp.innerHTML;
    }
  },
  methods: {
    updateInsurance(aspect) {
      this.insurance_co = aspect
    },
    updateAgency(aspect) {
      this.agency = aspect
    },
    async toggleInsuranceMore() {
      this.showInsuranceMore = !this.showInsuranceMore;
      if (this.showInsuranceMore && !this.insuranceDetail && this.insurance_co.id) {
        const res = await AspectDataService.getDetail(this.insurance_co.id);
        this.insuranceDetail = res.data;
      }
    },
    async toggleAgencyMore() {
      this.showAgencyMore = !this.showAgencyMore;
      if (this.showAgencyMore && !this.agencyDetail && this.agency.id) {
        const res = await AspectDataService.getDetail(this.agency.id);
        this.agencyDetail = res.data;
      }
    },
    get_user(id, key) {
      UserDataService.getById(id).then(res => {
        this[key].push(res.data)
      })
    },
    attached(data) {
      this.attached_data = data
    },
    loadPaymentSummary() {
      PolicyDataService.getPayments(this.$route.params.policy_key).then(
        res => {
          this.payments = res.data
          this.payment_summary = res.meta
        }
      )
    },
  },
  watch: {
    policy() {
      document.title = `Policy #${this.policy.policy_number}`
    },
    attached_data: function () {
      AttachmentDataService.getByRef(this.$route.params.policy_key).then((res) => {
        this.attachments = res.data;
      });
    }
  },
}
</script>

<style scoped>
.rich-text-content {
  line-height: 1.6;
}

.rich-text-content a,
.rich-text-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  pointer-events: auto;
}

.rich-text-content a:hover,
.rich-text-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.rich-text-content a:visited,
.rich-text-link:visited {
  color: #6c40bf;
}

/* Ensure links are clickable and visible */
.rich-text-content a {
  position: relative;
  z-index: 1;
}

/* Fix any potential CSS conflicts */
.rich-text-content * {
  pointer-events: auto;
}
</style>
